import React, { useEffect, useState } from 'react';
import { Box, TableBody, TableCell, TableRow } from '@mui/material';
import ChildHeader from '../../../components/ui/ChildHeader';
import { PersitedDatePicker, TableCustom } from '../../../components/common';
import { useQuery } from '../../../hooks/UseQuery';
import { useNavigate } from 'react-router-dom';
import { getDailyProductionYearly } from './helpers/utils';
import { EditIconButton } from '../../../components/common/button/CustomIconButton';

const Header = [
  [
    {
      text: '#',
      colspan: 1,
      rowspan: 1,
    },

    {
      text: 'MONTH & YEAR',
      colspan: 1,
      rowspan: 1,
    },
    {
      text: 'ACTION',
      colspan: 1,
      rowspan: 1,
    },
  ],
];

const List = () => {
  const [monitoringList, setMoniteringList] = useState<{ month_year: string }[]>([]);
  const heading = useQuery('heading') || '';
  const date = useQuery('date');
  const navigate = useNavigate();
  useEffect(() => {
    let data = getDailyProductionYearly(date);
    setMoniteringList(data);
  }, [date]);
  return (
    <>
      <ChildHeader text={heading}></ChildHeader>
      <div style={{ display: 'flex', margin: '1rem' }}>
        <Box sx={{ margin: 2 }}>
          <PersitedDatePicker label="Year" views={['year']} />
        </Box>
      </div>
      <TableCustom tableHeaderObj={Header}>
        <TableBody>
          {monitoringList.map((item: any, index) => (
            <React.Fragment>
              <TableRow>
                <TableCell align="center">{index + 1}</TableCell>
                <TableCell align="center">{item.month_year}</TableCell>
                <TableCell align="center">
                  <EditIconButton
                    tooltipTitle="edit"
                    onClick={() =>
                      navigate(
                        `/common/breakDownAnalysisGraphTabs/dashboard?annual_date=${item.month_year}`
                      )
                    }
                  />
                </TableCell>
              </TableRow>
            </React.Fragment>
          ))}
        </TableBody>
      </TableCustom>
    </>
  );
};

export default List;
